import { render, staticRenderFns } from "./NormalCommentArea.vue?vue&type=template&id=5248708c&scoped=true"
import script from "./NormalCommentArea.vue?vue&type=script&lang=js"
export * from "./NormalCommentArea.vue?vue&type=script&lang=js"
import style0 from "./NormalCommentArea.vue?vue&type=style&index=0&id=5248708c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5248708c",
  null
  
)

export default component.exports